import { __spreadArrays } from '../../../_virtual/_tslib.js';
import { extrapolateTemplate } from './templates.js';
import { SORTED_BREAKPOINT_NAMES, COLUMN_BREAKPOINT_TUPLES } from './breakpoints.js';
import upperFirst from 'lodash/upperFirst';

var AREAS_PROP_NAMES = __spreadArrays(['areas'], SORTED_BREAKPOINT_NAMES.map(function (breakpointName) {
  return "areas" + upperFirst(breakpointName);
}));
/**
 * Infer missing breakpoint props from a given `ResponsiveGridAreaProps`:
 *   i.e. { "areasXs": "a b c", "areasSm": "a a a b b c", ... }
 *
 * For each breakpoint where the number of columns change, we attempt to extrapolate
 *   the template from the closest smaller breakpoint with a template provided.
 */


function extrapolateProps(providedProps) {
  // Copy the props and re-type with an index signature so we can dynamically access `areasX` later
  var extrapolatedProps = Object.assign({}, providedProps); // COLUMN_BREAKPOINT_TUPLES contains a set of each breakpoint at which the number of columns changes

  COLUMN_BREAKPOINT_TUPLES.forEach(function (_a) {
    var columnBreakpointName = _a[0],
        columnCount = _a[1];
    var areasPropName = "areas" + upperFirst(columnBreakpointName); // If we already have a template for this breakpoint, skip

    if (providedProps.hasOwnProperty(areasPropName)) {
      return;
    } // Otherwise, find the closest smaller template and extrapolate from there


    var smallerPropNames = AREAS_PROP_NAMES.slice(0, AREAS_PROP_NAMES.indexOf("areas" + upperFirst(columnBreakpointName)));
    var sourceTemplate = null;

    for (var _i = 0, _b = smallerPropNames.reverse(); _i < _b.length; _i++) {
      var areasPropName_1 = _b[_i];
      var smallerBreakpointTemplate = providedProps[areasPropName_1];

      if (smallerBreakpointTemplate) {
        sourceTemplate = smallerBreakpointTemplate;
        break;
      }
    } // Extrapolate the template to the next breakpoint where the number of columns change


    if (sourceTemplate) {
      extrapolatedProps[areasPropName] = extrapolateTemplate(sourceTemplate, columnCount);
    }
  });
  return extrapolatedProps;
}

export default extrapolateProps;
//# sourceMappingURL=extrapolateProps.js.map
